import { YStack } from 'tamagui';

import PSText from '@/components/ui/PSText';

/**
 * Section — a consistent wrapper for page sections with headers (molecule).
 *
 * Enforces a standard header style (PSText.H1) while allowing the copy to be
 * customized. All section headers in the app use this component to maintain
 * visual consistency — the UX writer can change the header text via the
 * `headerLabel` prop without touching the component's styling.
 *
 * The header and content are both part of this component, so they share the
 * same gap and styling rules. Place this at the page level; the content inside
 * owns its own internal structure.
 */
export default function Section({
  headerLabel,
  children,
}: {
  /** The section header text — fully customizable by the UX writer. */
  headerLabel: string;
  /** The section's content — renders below the header. */
  children: React.ReactNode;
}) {
  return (
    <YStack gap="$md">
      <PSText.H1 color="$textDark">{headerLabel}</PSText.H1>
      {children}
    </YStack>
  );
}
